import React, { useState } from "react";
import "./Login.css";
import AuthService from "../services/AuthService";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import PasswordInput from "../components/PasswordInput";

function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [pending, setPending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pending) return;
    if (password.length < 8) {
      toast.error("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirm) {
      toast.error("Passwords do not match.");
      return;
    }
    setPending(true);
    try {
      await AuthService.resetPassword({ token, newPassword: password });
      toast.success("Password updated. You can now sign in.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(err?.message || "Reset failed.");
    } finally {
      setPending(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-bg" />
      <div className="auth-shell">
        <div className="auth-card">
          <h2 className="auth-title">Choose a new password</h2>
          {!token ? (
            <p className="auth-text">
              This reset link is invalid or incomplete. Please request a new one from the{" "}
              <Link to="/forgot-password">forgot password</Link> page.
            </p>
          ) : (
            <form onSubmit={submit}>
              <PasswordInput
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="New password (min 8 characters)"
                autoComplete="new-password"
                autoFocus
              />
              <PasswordInput
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder="Confirm new password"
                autoComplete="new-password"
              />
              <button type="submit" className="auth-btn auth-btnPrimary" disabled={pending}>
                {pending ? "Updating…" : "Update password"}
              </button>
            </form>
          )}
          <div className="auth-links">
            <Link to="/login">Back to sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
